import { Navigate, Outlet, useLocation } from "react-router-dom";
import {
  eymemoryLogout,
  getEymemoryIsLoggedIn,
} from "src/shared/redux-state/src";
import { useAppSelector, useAppDispatch } from "../services/store";
import { EymemoryRoutes } from "../navigation/routes";
import { extractOrderHashFromPath } from "../utilities/helpers";

const EymemoryAuthGuard = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const hashForOrder = extractOrderHashFromPath(location.pathname);

  const isLoggedIn = useAppSelector(
    getEymemoryIsLoggedIn(
      hashForOrder || location?.state?.orderHash || undefined
    )
  );

  if (!isLoggedIn) {
    const orderHash = hashForOrder || location?.state?.orderHash;
    dispatch(eymemoryLogout({ orderHash }));

    return (
      <Navigate
        to={`${EymemoryRoutes.EYMEMORIES_ERROR}${
          orderHash ? `?orderHash=${orderHash}` : ""
        }`}
        state={{ orderHash }}
        replace
      />
    );
  }

  return <Outlet />;
};

export default EymemoryAuthGuard;
